module.exports = __webpack_public_path__ + "static/media/CaslonGraphiqueEF.507023d6.ttf";